// describes options relating to a product itself - only relevant for paper currently
const NoProductOptions = 'NoProductOptions';
const Saturday = 'Saturday';
const SaturdayPlus = 'SaturdayPlus';
const Sunday = 'Sunday';
const Weekend = 'Weekend';
const WeekendPlus = 'WeekendPlus';
const Sixday = 'Sixday';
const SixdayPlus = 'SixdayPlus';
const Everyday = 'Everyday';
const EverydayPlus = 'EverydayPlus';
const NewspaperArchive = 'NewspaperArchive';
export { NoProductOptions, Saturday, SaturdayPlus, Sunday, Weekend, WeekendPlus, Sixday, SixdayPlus, Everyday, EverydayPlus, NewspaperArchive, };
